import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/style/common.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/assets/style/css-vars.css'


import directives from '@/directive'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import 'dayjs/locale/zh-cn';

let app = createApp(App)
app.use(router).use(store)
app.use(ElementPlus, { locale })

// 安装所有的自定义指令
for(let key in directives ){
    //console.log(key)
    app.directive(key,directives[key]);
}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

// import InputNumberRange from '@/components/common/inputNumberRange.vue' 
// app.component(InputNumberRange.name, InputNumberRange)
app.mount('#app')
